import { request } from "../api";

export const getStatus = () => request.get("/assistant/status");
export const chat = (messages, language) => request.post("/assistant/chat", { messages, language });
export const listActions = () => request.get("/assistant/actions");
export const confirmAction = id => request.post(`/assistant/actions/${id}/confirm`);
export const dismissAction = id => request.post(`/assistant/actions/${id}/dismiss`);
export const listLetters = () => request.get("/assistant/letters");
export const letterBlob = id => request.blob(`/assistant/letters/${id}`);
export const generateLetter = (period, body) =>
  request.post(`/assistant/letters/${period}/generate`, body || {});
export const explainRule = topic => request.get(`/assistant/rules/${encodeURIComponent(topic)}`);
